import { useOrganizationStore } from '@/stores/organization.store'
import type { ApplicationModule } from '../models/organization'

export const useApplicationModule = () => {
  const organizationStore = useOrganizationStore()

  const hasModule = (module: ApplicationModule): boolean => {
    return organizationStore.currentOrganization.modules.includes(module)
  }

  return { hasModule }
}
